var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{attrs:{"id":"app"}},[_c('router-view')],1):_c('div',{staticClass:"fullscreen loading"},[_c('font-awesome-icon',{staticClass:"beast-spinner",attrs:{"icon":_vm.faCircleNotch,"spin":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }